import type { Vehicle } from '@bambi/api-client/schemas';

import { defaultFormValues } from './defaultFormValues';
import type { FormValues } from './FormValues';

export function assignDefaultFormValues(
  vehicle: Vehicle | undefined
): FormValues {
  return {
    ...defaultFormValues,
    ...(vehicle || {}),
    storage_location: vehicle?.storage_location
      ? {
          label: vehicle.storage_location.label,
          value: vehicle.storage_location.place_id,
        }
      : null,
  };
}
